import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportNoticesTopicMutation,
  ExportNoticesTopicMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportNoticesTopic = graphql(`
  mutation exportNoticesTopic(
    $input: NoticeTopicSearchInput!
    $exportFormat: ExportFormatArgs!
    $selectedNotices: SelectedNotices!
    $selectedFields: [SelectedFields_SelectedFieldsEnum_0!]
  ) {
    exportNoticesTopic(
      NoticeTopicSearchInput: $input
      ExportFormat: $exportFormat
      SelectedNotices: $selectedNotices
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useNoticeTopicExport(
  options?: UseMutationOptions<
    ExportNoticesTopicMutation,
    unknown,
    ExportNoticesTopicMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportNoticesTopic, options);
  return { ...rest, data: data?.exportNoticesTopic };
}
